import React, { useEffect, useRef, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { addProducts, deleteProduct, updateProducts } from '../../actions/userActions/productAction';
import { Redirect, useLocation, useHistory } from 'react-router-dom';
import AddDocument from '../subComponents/buttons/AddDocument';
import Add_Document_Icon from '../../../src/assets/images/add_document_icon.svg';
import Excel_icon from "../../assets/images/Excel_icon.svg";
import Pdf_icon from "../../assets/images/Pdf_icon.svg";
import Word_icon from "../../assets/images/Word_icon.svg";
import Ppt_icon from "../../assets/images/Ppt_icon.svg";
import Access_icon from "../../assets/images/Access_icon.svg";
import Txt_icon from "../../assets/images/Txt_icon.svg";
import Folder_icon from "../../assets/images/Folder_icon.svg";
import { toast } from "react-toastify";
import './Product.css';
import productIcon from "../../assets/images/Icon=Products.svg";
import closeModal from "../../assets/images/closeModal.svg";
import BodyExtraSmallMedium from '../designSystem/BodyExtraSmallMedium';
import { IconButton } from '@mui/material';
import TextField from '../designSystem/TextField';
import BodyLargeMedium from '../designSystem/BodyLargeMedium';
import Textarea from '../designSystem/TextArea';
import { Check, CloudUpload, X } from 'lucide-react';
import Delete from '@mui/icons-material/Delete';
import { validateFields } from '../../utils/Validations';
import CancelButton from '../subComponents/buttons/CustomCancelButton';
import PrimaryButton from '../subComponents/buttons/PrimaryButton';
import { t } from '../../locales/translate';

function AddProducts({ onClose, editData, onSave }) {
    const dispatch = useDispatch();
    const location = useLocation();
    const fileInputRef = useRef(null);
    const initialValues = {
        name: "",
        description: "",
        active: false,
        file: [],
        urls: []
    };

    const [formValues, setFormValues] = useState(initialValues);
    const [formErrors, setFormErrors] = useState({});
    const permissions = JSON.parse(localStorage.getItem("permissionsList"));
    const getFileIcon = (fileName) => {
        const extension = fileName?.split('.').pop().toLowerCase();
        switch (extension) {
            case "pdf":
                return Pdf_icon;
            case "xls":
            case "xlsx":
                return Excel_icon;
            case "doc":
            case "docx":
                return Word_icon;
            case "ppt":
            case "pptx":
                return Ppt_icon;
            case "accdb":
                return Access_icon;
            case "txt":
                return Txt_icon;
            default:
                return Folder_icon;
        }
    };
    useEffect(() => {
        if (editData) {
            setFormValues({
                ...formValues,
                ["name"]: editData.name,
                ["description"]: editData.description,
                ["id"]: editData.id,
                ["active"]: editData.active,
                ["urls"]: editData.urls || []
            });
        }
    }, [editData]);
    const handleSave = async (e) => {
        e.preventDefault();
        const errors = validateFields(formValues, 'product');
        setFormErrors(errors);
        if (Object.keys(errors).length > 0) return;

        const data = new FormData();
        data.append('name', formValues.name);
        data.append('description', formValues.description);
        data.append('active', formValues.active);
        formValues.file.forEach(file => data.append('file', file));

        if (editData) {
            data.append('id', formValues.id);
            await dispatch(updateProducts(data));
        } else {
            await dispatch(addProducts(data));
        }

        await onSave(data);
    };

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFormValues(prevValues => ({
            ...prevValues,
            [name]: type === "checkbox" ? checked : value
        }));
    };

    const getfileName = (text) => {
        const fileNameWithExtension = text?.split("forms/").pop();
        if (fileNameWithExtension) {
            const fileNameWithoutExtension = fileNameWithExtension.split('.').slice(0, -1).join('.');
            return fileNameWithoutExtension;
        }
        return '';
    };

    const handleUploadButtonClick = () => {
        fileInputRef.current.click();
    };

    const handleFileUpload = (e) => {
        const newFiles = e.target.files;
        const updatedFiles = Array.isArray(formValues.file) ? [...formValues.file] : [];
        const updatedUrls = Array.isArray(formValues.urls) ? [...formValues.urls] : [];
        let filesAdded = false;

        const uniqueFiles = Array.from(newFiles).filter((file) => {
            const fileNamesInUrls = updatedUrls.map(url => url.split('/').pop());
            return !fileNamesInUrls.includes(file.name);
        });

        uniqueFiles.forEach((file) => {
            updatedFiles.push(file);
            updatedUrls.push(file.name);
            filesAdded = true;
        });

        if (filesAdded) {
            setFormValues(prevValues => ({
                ...prevValues,
                file: updatedFiles,
                urls: updatedUrls,
            }));
        }
    };

    const handleDeleteProduct = (id, fileName) => {
        const updatedFiles = formValues.file.filter((file) => {
            return !file.name.includes(fileName);
        });

        const updatedUrls = formValues.urls.filter((url) => {
            return !url.includes(fileName);
        });
        setFormValues({
            ...formValues,
            file: updatedFiles,
            urls: updatedUrls,
        });

        dispatch(deleteProduct(id, fileName));
    };

    return (
        <div className="dynamicmodal-overlay">
            <div className="dynamicmodal-container">
                <div className="dynamicmodal-header mb-3">
                    <div className="dynamicmodal-header-left">
                        <div className="icon">
                            <img src={productIcon} alt="productIcon" />
                        </div>
                        <div className="text">
                            <h2 className="modalheading">
                                {editData ? "Edit Product" : `${t("addProduct")}`}
                            </h2>
                            <p className="modaldescription">
                               {t("addProductTip")}
                            </p>
                        </div>
                    </div>
                    <div className="dynamicmodal-header-right">
                        <IconButton onClick={onClose}>
                            <img src={closeModal} alt="" />
                        </IconButton>
                    </div>
                </div>

                <form onSubmit={handleSave}>
                    <div className="dynamicmodal-body">
                        <TextField
                            name="name"
                            label={`${t("name")} *`}
                            type="text"
                            value={formValues.name}
                            onChange={handleChange}
                            placeholder={t("name")}
                            error={formErrors.name}
                        />

                        <Textarea
                            name="description"
                            label={`${t("description")} *`}
                            placeholder={t("description")}
                            value={formValues.description}
                            onChange={handleChange}
                            error={formErrors.description}
                        />
                        <div className="col-12">
                            <h6 className={`mb-3 ${document.body.dir === "rtl" ? "text-end" : "text-start"}`}>{t("attachedDocuments")}</h6>

                            {Array.isArray(formValues.urls) && formValues.urls.filter(url => url.trim() !== "").length > 0 ? (
                                <div className="files-list">
                                    {formValues.urls.map((file, index) => (
                                        file.trim() !== "" && (
                                            <div key={index} className="file-row">
                                                <div className="file-info">
                                                    <img
                                                        src={getFileIcon(file)}
                                                        alt="File Type Icon"
                                                        className="file-icon"
                                                    />
                                                    <span className="file-name">{getfileName(file)}</span>
                                                </div>
                                                <IconButton onClick={() => {
                                                    handleDeleteProduct(formValues.id, getfileName(file));
                                                }}>
                                                    <Delete />
                                                </IconButton>
                                            </div>
                                        )
                                    ))}
                                </div>
                            ) : (
                                <p className={`no-files-text ${document.body.dir === "rtl" ? "text-end" : "text-start"}`}>{t("noFilesAttached")}</p>
                            )}


                        </div>
                        <div className={`upload-area ${formValues.urls.filter((url) => url.trim() !== "").length > 0 ? "uploaded" : ""}`} onClick={handleUploadButtonClick}>
                            <CloudUpload />
                            <span className="upload-text">{t("clickToUpload")}</span>
                            <p className="upload-formats">{t("acceptedFormats")}: .pdf, .xls, .xlsx, .doc, .docx, .ppt</p>
                        </div>
                        <div className=" mt-2 ml-0">
                            <div
                                className="form-group"
                                style={{ display: "flex", alignItems: "flex-start" }}
                            >
                                <input
                                    name="active"
                                    style={{ cursor: "pointer", height: "14px", width: "14px" }}
                                    type="checkbox"
                                    checked={formValues.active}
                                    className="ml-1 mt-1"
                                    onChange={handleChange}
                                />
                                <label
                                    style={{ paddingLeft: "5px" }}
                                    className="form-control-label"
                                >
                                    <div style={{ padding: '2px' }}>
                                        <BodyExtraSmallMedium text={t("active")} color="#1E293B" />
                                    </div>
                                </label>
                            </div>
                        </div>

                    </div>
                    <div className="dynamicmodal-footer">
                        <CancelButton
                        onClick={onClose}
                        text={t("cancel")}
                        width={document.body.dir === "rtl" ? "119px" : ""}
                        />
                        <PrimaryButton
                        text={t("save")}
                        icon={Check}
                        width={document.body.dir === "rtl" ? "123px" : ""}
                        />
                    </div>
                </form>

                <input
                    type="file"
                    ref={fileInputRef}
                    style={{ display: "none" }}
                    onChange={handleFileUpload}
                    accept=".pdf, .xls, .xlsx, .doc, .docx, .ppt, .pptx, .txt, .accdb"
                    multiple
                />
            </div>
        </div>
    );
}

export default AddProducts;